import { waitUntilGliderIsLoaded } from "./_waitUntilGliderIsLoaded";

class NProductTeaasersSlider {
    constructor(wrapperEl) {
        this.wrapperEl = wrapperEl
        this.teasers = this.wrapperEl.querySelectorAll('.teaser-card');

        if (!this.teasers) return;

        // Create slider markup with correct elements
        this._slider = this._createSlider();

        // Add the slider to the wrapper element
        this.wrapperEl.appendChild(this._slider)

        // Initialize the slider
        this._initSlider();
    }

    _createSlider() {
        // Create slider elements
        const sliderWrapper = document.createElement("div");
        sliderWrapper.classList.add("slider-wrapper");

        this._slider = document.createElement('toujou-slider');
        this._slider.classList.add("slider--n-product-teasers", 'slider');

        this._sliderFrame = document.createElement("div");
        this._sliderFrame.classList.add('slider__frame');

        // Add cards to the new slider markup
        this.teasers.forEach((teaser) => {
            this._sliderFrame.appendChild(teaser);
        });

        this._slider.appendChild(this._sliderFrame);

        // Create controls
        this._controlsWrapper = document.createElement('div');
        this._controlsWrapper.classList.add('controls-wrapper');

        this._sliderBulletsContainer = document.createElement('div');
        this._sliderBulletsContainer.classList = 'slider__bullets';

        const arrowLeftSVG = `<svg height="24" width="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use xlink:href="#arrow_left"></use></svg>`;
        const arrowRightSVG = `<svg height="24" width="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use xlink:href="#arrow_right"></use></svg>`;

        this._sliderArrowPrev = document.createElement('span');
        this._sliderArrowPrev.classList = 'slider__control slider__control--prev';
        this._sliderArrowPrev.insertAdjacentHTML('beforeend', arrowLeftSVG);

        this._sliderArrowNext = document.createElement('span');
        this._sliderArrowNext.classList = 'slider__control slider__control--next';
        this._sliderArrowNext.insertAdjacentHTML('beforeend', arrowRightSVG);

        // Add controls to controls wrapper
        this._controlsWrapper.appendChild(this._sliderArrowPrev);
        this._controlsWrapper.appendChild(this._sliderBulletsContainer);
        this._controlsWrapper.appendChild(this._sliderArrowNext);

        // Add controls wrapper with controls to the slider element
        this._slider.appendChild(this._controlsWrapper);

        return this._slider;
    }

    _initSlider() {
        try {
            const sliderOptions = {
                slidesToShow: 1,
                slidesToScroll: 1,
                rewind: true,
                draggable: true,
                scrollLock: true,
                responsive: [
                    {
                        breakpoint: 540,
                        settings: { slidesToShow: 2 },
                    },
                    {
                        breakpoint: 960,
                        settings: { slidesToShow: 3 },
                    },
                ],
                arrows: {
                    prev: this._sliderArrowPrev,
                    next: this._sliderArrowNext,
                },
                dots: this._sliderBulletsContainer,
            };

            this._slider._glider = new Glider(this._sliderFrame, sliderOptions);
            this._slider._glider.refresh(true);
        } catch (error) {
            console.log('Could not initialize the product teaser slider', error)
        }
    }
}

export async function initNProductTeaserSlider() {
    const nProductTeaserSliders = document.querySelectorAll('.n-product-teasers-slider');
    if (!nProductTeaserSliders) return;

    const gliderAvailable = await waitUntilGliderIsLoaded();

    nProductTeaserSliders.forEach((wrapperEl) => {
        new NProductTeaasersSlider(wrapperEl);
    })
}
